import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import compose from 'recompose/compose';
import { Form, reduxForm } from 'redux-form';
import { changeStepOfProfessionalSolution } from '../../../../../actions/ProfessionalSolutionActions';
import { arrayMapFirst } from '../../../../../helpers/common/ArrayHelper';
import { propArrayShape, propBool, propFunc, propNumber, propShape, ReduxFormProps, } from '../../../../../helpers/custom-prop-types';
import { scrollToWithHeaderHeight } from '../../../../../helpers/ScrollUtils';
import { scrollToTop } from '../../../../../helpers/ui';
import { validateRegion, validateSubMiddleClasses, validateTags, } from '../../../../../validate/solution';
import FormSolutionStep1 from './FormSolutionStep1';
import FormSolutionStep2 from './FormSolutionStep2';
import FormSolutionStep3 from './FormSolutionStep3';
import FormSolutionStep4 from './FormSolutionStep4';
import FormSolutionStep5 from './FormSolutionStep5';
const FormSolutionCreate = (props) => {
    const { error, formFields, goBackStep, goNextStep, handleSubmit, invalid, isLoading, isSubmitLoading, solutionLargeClasses, solutionMiddleClasses, solutionTags, step, touch, } = props;
    const dispatch = useDispatch();
    const onClickNext = useCallback((clickStep, touchFields, errorViewFields = []) => {
        touchFields.forEach((field) => dispatch(touch(field)));
        const firstError = touchFields.find((field) => !!_.get(formFields, `syncErrors.${field}`));
        if (firstError) {
            if (errorViewFields.includes(firstError)) {
                scrollToWithHeaderHeight(`${firstError}_view`);
            }
            else {
                scrollToWithHeaderHeight(firstError);
            }
        }
        else {
            goNextStep(clickStep);
        }
    }, [dispatch, formFields, goNextStep, touch]);
    return (_jsxs(Form, Object.assign({ onSubmit: handleSubmit, style: { width: '100%' } }, { children: [_jsx(FormSolutionStep1, { formFields: formFields, onClickNext: onClickNext, solutionLargeClasses: solutionLargeClasses, solutionMiddleClasses: solutionMiddleClasses, solutionTags: solutionTags, style: { display: step === 1 ? 'block' : 'none' } }), _jsx(FormSolutionStep2, { formFields: formFields, goBackStep: goBackStep, onClickNext: onClickNext, style: { display: step === 2 ? 'block' : 'none' } }), _jsx(FormSolutionStep3, { formFields: formFields, goBackStep: goBackStep, onClickNext: onClickNext, style: { display: step === 3 ? 'block' : 'none' } }), _jsx(FormSolutionStep4, { formFields: formFields, goBackStep: goBackStep, onClickNext: onClickNext, style: { display: step === 4 ? 'block' : 'none' } }), _jsx(FormSolutionStep5, { error: error && invalid ? error : '', formFields: formFields, goBackStep: goBackStep, isLoading: isLoading, isSubmitLoading: isSubmitLoading, style: { display: step === 5 ? 'block' : 'none' } })] })));
};
FormSolutionCreate.propTypes = Object.assign(Object.assign({}, ReduxFormProps), { formFields: propShape().isRequired, goBackStep: propFunc().isRequired, goNextStep: propFunc().isRequired, isLoading: propBool().isRequired, isSubmitLoading: propBool().isRequired, solutionLargeClasses: propArrayShape().isRequired, solutionMiddleClasses: propArrayShape().isRequired, solutionTags: propArrayShape().isRequired, step: propNumber().isRequired, touch: propFunc().isRequired });
const mapStateToProps = ({ category, form, professionalSolution }) => ({
    formFields: form.FormSolutionCreate || {},
    solutionLargeClasses: category.solutionLargeClass,
    solutionMiddleClasses: category.solutionMiddleClass,
    solutionTags: category.solutionTag,
    step: professionalSolution.step,
});
const mapDispatchToProps = (dispatch) => ({
    goBackStep: (step) => {
        dispatch(changeStepOfProfessionalSolution(step - 1));
        scrollToTop();
    },
    goNextStep: (step) => {
        dispatch(changeStepOfProfessionalSolution(step + 1));
        scrollToTop();
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({
    form: 'FormSolutionCreate',
    validate: (values) => {
        const list = [
            {
                name: 'subMiddleClasses_list',
                validate: validateSubMiddleClasses,
                value: 'subMiddleClasses',
            },
            {
                name: 'tags_list',
                validate: validateTags,
                value: 'tags',
            },
            {
                name: 'regions_list',
                validate: validateRegion,
                value: 'regions',
            },
        ];
        const errors = {};
        list.forEach((row) => {
            const error = arrayMapFirst(row.validate, (v) => v(values[row.value]));
            if (error) {
                errors[row.name] = error;
            }
        });
        return errors;
    },
}));
export default enhance(FormSolutionCreate);
